import React from "react";
import { Box, TextField, Typography } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function SendToInventoryTable({
  data,
  tableData,
  onDataChange,
}) {
  const columns = [
    {
      accessorKey: "description",
      header: "Description",
      size: 200,
      enableEditing: false,
      Cell: ({ row }) => row.original.left?.description || "-",
    },
    {
      accessorKey: "pnidQuantity",
      header: "PNID Quantity",
      size: 100,
      enableEditing: false,
      Cell: ({ row }) => row.original.left?.quantity || "-",
    },
    {
      accessorKey: "2dQuantity",
      header: "2D Quantity",
      size: 100,
      enableEditing: false,
      Cell: ({ row }) => row.original.right?.quantity || "-",
    },
    {
      accessorKey: "delta",
      header: "Difference",
      size: 100,
      enableEditing: false,
      Cell: ({ row }) =>
        row.original.left?.quantity - row.original.right?.quantity || "-",
    },
    {
      accessorKey: "spareQty",
      header: "Spare Qty",
      size: 150,
      enableEditing: true,
      Cell: ({ row }) => {
        const key = row.original.key;

        return (
          <TextField
            size="small"
            value={tableData[key]?.spareQty || ""}
            autoComplete="off"
            onChange={(e) => onDataChange(key, "spareQty", e.target.value)}
            placeholder="Spare Qty"
          />
        );
      },
    },
  ];

  const table = useMaterialReactTable({
    columns,
    data,
    ...lightTable,
    enableStickyHeader: true,
    muiTableContainerProps: {
      sx: { maxHeight: "300px" },
    },
  });

  return (
    <Box>
      <MaterialReactTable table={table} />

      <Typography
        variant="body2"
        sx={{
          mt: 1,
          fontStyle: "italic",
        }}
      >
        * Spare Qty will be added to inventory count
      </Typography>
    </Box>
  );
}
